export const getFarmUWInitialValues = (farmVerification = {}) => {
  const initialValues = {
    // Eligibility questions
    unrepairedDamage: farmVerification?.unrepairedDamage?.toString() || null,
    unrepairedDamageDetails: farmVerification?.unrepairedDamageDetails || '',
    priorFireLoss: farmVerification?.priorFireLoss?.toString() || null,
    priorFireLossDetails: farmVerification?.priorFireLossDetails || '',
    priorLiabilityLoss: farmVerification?.priorLiabilityLoss?.toString() || null,
    priorLiabilityLossDetails: farmVerification?.priorLiabilityLossDetails || '',
    chargedWithFelony: farmVerification?.chargedWithFelony?.toString() || null,
    chargedWithFelonyDetails: farmVerification?.chargedWithFelonyDetails || '',
    foreclosureBankruptcy: farmVerification?.foreclosureBankruptcy?.toString() || null,
    foreclosureBankruptcyDetails: farmVerification?.foreclosureBankruptcyDetails || '',
    coverageDeclined: farmVerification?.coverageDeclined?.toString() || null,
    coverageDeclinedDetails: farmVerification?.coverageDeclinedDetails || '',

    // Property risk factor questions
    otherResidences: farmVerification?.otherResidences?.toString() || null,
    otherResidencesDetails: farmVerification?.otherResidencesDetails || '',
    dwellingsForSale: farmVerification?.dwellingsForSale?.toString() || null,
    dwellingsForSaleDetails: farmVerification?.dwellingsForSaleDetails || '',
    unlistedStructures: farmVerification?.unlistedStructures?.toString() || null,
    unlistedStructuresDetails: farmVerification?.unlistedStructuresDetails || '',
    recreationalVehicles: farmVerification?.recreationalVehicles?.toString() || null,
    recreationalVehiclesDetails: farmVerification?.recreationalVehiclesDetails || '',
    livestockFencing: farmVerification?.livestockFencing?.toString() || null,
    livestockFencingDetails: farmVerification?.livestockFencingDetails || '',
    livestockEscape: farmVerification?.livestockEscape?.toString() || null,
    livestockEscapeDetails: farmVerification?.livestockEscapeDetails || '',
    solarPanels: farmVerification?.solarPanels?.toString() || null,
    solarPanelsDetails: farmVerification?.solarPanelsDetails || '',
    dogsOrExoticPets: farmVerification?.dogsOrExoticPets?.toString() || null,
    dogsOrExoticPetsDetails: farmVerification?.dogsOrExoticPetsDetails || '',
    trampoline: farmVerification?.trampoline?.toString() || null,
    trampolineDetails: farmVerification?.trampolineDetails || '',
    dwellingsUnderRenovation: farmVerification?.dwellingsUnderRenovation?.toString() || null,
    dwellingsUnderRenovationDetails: farmVerification?.dwellingsUnderRenovationDetails || '',

    // Operational details questions
    businessConductedOnPremises: farmVerification?.businessConductedOnPremises?.toString() || null,
    businessConductedOnPremisesDetails: farmVerification?.businessConductedOnPremisesDetails || '',
    dayCareBusiness: farmVerification?.dayCareBusiness?.toString() || null,
    dayCareBusinessDetails: farmVerification?.dayCareBusinessDetails || '',
    anhydrousAmmoniaEquipment: farmVerification?.anhydrousAmmoniaEquipment?.toString() || null,
    anhydrousAmmoniaEquipmentDetails: farmVerification?.anhydrousAmmoniaEquipmentDetails || '',
    processOrManufacture: farmVerification?.processOrManufacture?.toString() || null,
    processOrManufactureDetails: farmVerification?.processOrManufactureDetails || '',
    huntingOrFishingFee: farmVerification?.huntingOrFishingFee?.toString() || null,
    huntingOrFishingFeeDetails: farmVerification?.huntingOrFishingFeeDetails || '',
    customFarming: farmVerification?.customFarming?.toString() || null,
    customFarmingDetails: farmVerification?.customFarmingDetails || '',

    // Attestation
    signedFarmUWAttestation: farmVerification?.signedFarmUWAttestation || false
  };

  return initialValues;
};

export default getFarmUWInitialValues;
